import React from 'react'

// components
import FormAttributes from '../../FormComponents/FormAttributes'

export default function AttributesTab(props) {
    const {
        formik,

        brands,

        productAttributes,
        setSelectedProductsAttributes,
        selectedProductsAttributes,
    } = props

    return (
        <React.Fragment>
            {/* images */}
            <FormAttributes
                formik={formik}

                brands={brands}

                productAttributes={productAttributes}
                setSelectedProductsAttributes={setSelectedProductsAttributes}
                selectedProductsAttributes={selectedProductsAttributes}
            />

            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fs-15 st-fw-600 st-text-color mb-2">Marketplace category</p>
                    <p className="st-fs-13 st-text-color2 mb-3">
                        Categorize your product by sepcifying a general category that best describes all of them. This will make your products more discoverable to your customers on marketplace.
                        After specifying the general category that will be assigned as default, you can also set the category for this particular product.
                    </p>
                    <button className="st-btn st-btn-primary st-btn-sm text-capitalize st-fw-400 st-fs-13">
                        specify category
                    </button>
                </div>
            </div>
        </React.Fragment>
    )
}
